import React from 'react';
import './ExportActions.css';

export function ExportActions({
  onCsv,
  onExcel,
  onPrint,
  disabled = false,
  showCsv = true,
  showExcel = true,
  showPrint = true,
  printLabel = '🖨️ Imprimir',
}) {
  if (!onCsv && !onExcel && !onPrint) return null;
  return (
    <div className="export-actions">
      {showCsv && onCsv && (
        <button type="button" className="btn-secondary" onClick={onCsv} disabled={disabled}>
          CSV
        </button>
      )}
      {showExcel && onExcel && (
        <button type="button" className="btn-secondary" onClick={onExcel} disabled={disabled}>
          Excel
        </button>
      )}
      {showPrint && onPrint && (
        <button type="button" className="btn-primary" onClick={onPrint} disabled={disabled}>
          {printLabel}
        </button>
      )}
    </div>
  );
}
